<template>
  <div class="date-range-picker d-flex">
    <!-- Start Date Picker  -->
    <v-menu
      v-model="startDatePicker"
      :close-on-content-click="false"
      attach
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="startDateField"
          :label="startDateLabel"
          outlined
          class="pr-2"
          readonly
          v-bind="attrs"
          v-on="on"
          append-icon="mdi-calendar"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="startDateField"
        no-title
        scrollable
        color="primary"
        :max="endDateField"
      >
      </v-date-picker>
    </v-menu>
    <!-- End Date Picker -->
    <v-menu
      v-model="endDatePicker"
      :close-on-content-click="false"
      :nudge-right="-150"
      transition="scale-transition"
      offset-y
      attach
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="endDateField"
          :label="endDateLabel"
          outlined
          readonly
          v-bind="attrs"
          v-on="on"
          append-icon="mdi-calendar"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="endDateField"
        no-title
        color="primary"
        scrollable
        :min="startDateField"
      >
      </v-date-picker>
    </v-menu>
  </div>
</template>
<script>

/**
 * Display Date Range Picker
 */
export default {
  name: "DateRangePicker",

  /**
   * ------------- Props attribute ----------------
   */
  props: {
    startDate:{ type: String, required: true, default: ""},
    endDate: { type: String, required: true, default: ""},
    startDateLabel: {type: String, default: "Start Date"},
    endDateLabel: {type:String, default: "End Date"}
  },

  /**
   * -------------- Data attributes ---------------
   */
  data() {
    return {
      startDatePicker: false,
      endDatePicker: false,
    };
  },
  /**
   * --------------- Computed Properties -----------
   */
  computed:{
    /**
     * Start date of the calendar
     * @returns {Date} Date in string format
     */
    startDateField:{
      get(){
        return this.startDate;
      },
      set(value){
        this.$emit("update:start-date", value);
      }
    },
    /**
     * Enda date of the calendar
     * @returns {Date} Date in string format
     */
    endDateField:{
      get(){
        return this.endDate;
      },
      set(value){
        this.$emit("update:end-date", value);
      }
    }
  },

  /**
   * ---------------- Custom event emitted ---------------
   */
  emits: ["update:start-date", "update:end-date"],
};
</script>